export default __webpack_public_path__ + "static/media/GE.d8f25500.svg";